import CardModal from '../CardModal';
import More from '../More';
import css from './index.module.scss';
import { useGlobal } from '@/utils/useGlobal';
import NextImage from '@/components/NextImage';
import SVGArrow from '@/components/UI/svg/corporatesocialresponsibility/SVGArrow';
import SVGMore from '@/components/UI/svg/corporatesocialresponsibility/SVGMore';

export default function E() {
    const { useState, useLang, useRouter } = useGlobal();
    const { locale } = useRouter();
    const { t } = useLang('corporatesocialresponsibility');
    const [visible, setVisible] = useState(false);
    const [modalInfo, setModalInfo] = useState({});
    const [moreVisible, setMoreVisible] = useState(false);

    const clickCard = (card: any) => {
        setVisible(true);
        setModalInfo({
            title: card?.title,
            desc: card?.desc,
            imgs: card?.imgArr,
        });
    };

    const cards: any = [
        {
            title: t('secE_card10_text'),
            desc: t('secE_card10_desc'),
            webpImg: require('@publicLocal/corporate-social-responsibility/common/A1.jpg'),
            img: require('@publicLocal/corporate-social-responsibility/common/A1.jpg'),
            imgArr: [
                [require('@publicLocal/corporate-social-responsibility/common/A1.jpg'), require('@publicLocal/corporate-social-responsibility/common/A1.jpg')],
                [require('@publicLocal/corporate-social-responsibility/common/A2.jpg'), require('@publicLocal/corporate-social-responsibility/common/A2.jpg')],
                [require('@publicLocal/corporate-social-responsibility/common/A3.jpg'), require('@publicLocal/corporate-social-responsibility/common/A3.jpg')],
                [require('@publicLocal/corporate-social-responsibility/common/A4.jpg'), require('@publicLocal/corporate-social-responsibility/common/A4.jpg')],
            ],
        },
        {
            title: t('secE_card14_text'),
            desc: t(`secE_card14_desc`),
            imgArr: [
                ['https://websiteoss.ecoflow.com/upload/image/1734491671868/F14.jpg', 'https://websiteoss.ecoflow.com/upload/image/1734491671868/F14.jpg'],
            ],
            webpImg: 'https://websiteoss.ecoflow.com/upload/image/1734491671868/F14.jpg',
            img: 'https://websiteoss.ecoflow.com/upload/image/1734491671868/F14.jpg',
        },
        {
            title: t('secE_card1_text'),
            desc: t('secE_card1_desc'),
            webpImg: require('@publicLocal/corporate-social-responsibility/pc/5_1_1.webp'),
            img: require('@publicLocal/corporate-social-responsibility/pc/5_1_1.png'),
            imgArr: [
                [require('@publicLocal/corporate-social-responsibility/pc/5_1_1.webp'), require('@publicLocal/corporate-social-responsibility/pc/5_1_1.png')],
                [require('@publicLocal/corporate-social-responsibility/pc/5_1_2.webp'), require('@publicLocal/corporate-social-responsibility/pc/5_1_2.png')],
            ],
        },
        {
            title: t('secE_card2_text'),
            desc: t('secE_card2_desc'),
            webpImg: require('@publicLocal/corporate-social-responsibility/pc/5_2_1.jpg'),
            img: require('@publicLocal/corporate-social-responsibility/pc/5_2_1.jpg'),
            imgArr: [
                [require('@publicLocal/corporate-social-responsibility/pc/5_2_1.jpg'), require('@publicLocal/corporate-social-responsibility/pc/5_2_1.jpg')],
            ],
        },
    ];

    const moreArr: any = [
        {
            title: t('secE_card12_text'),
            desc: t('secE_card12_desc'),
            // webpImg: require('@publicLocal/corporate-social-responsibility/pc/5_3_1.jpg'),
            // img: require('@publicLocal/corporate-social-responsibility/pc/5_3_1.jpg'),
            imgs: [['https://websiteoss.ecoflow.com/upload/image/1734491541959/F13.jpg', 'https://websiteoss.ecoflow.com/upload/image/1734491541959/F13.jpg']],
        },
        {
            title: t('secE_card4_text'),
            desc: t('secE_card4_desc'),
            // webpImg: require('@publicLocal/corporate-social-responsibility/pc/5_4_1.jpg'),
            // img: require('@publicLocal/corporate-social-responsibility/pc/5_4_1.jpg'),
            imgs: [
                [require('@publicLocal/corporate-social-responsibility/pc/5_4_1.jpg'), require('@publicLocal/corporate-social-responsibility/pc/5_4_1.jpg')],
                [require('@publicLocal/corporate-social-responsibility/pc/5_4_2.jpg'), require('@publicLocal/corporate-social-responsibility/pc/5_4_2.jpg')],
            ],
        },
        {
            imgs: [
                [require('@publicLocal/corporate-social-responsibility/pc/5_5_1.webp'), require('@publicLocal/corporate-social-responsibility/pc/5_5_1.png')],
                [require('@publicLocal/corporate-social-responsibility/pc/5_5_2.webp'), require('@publicLocal/corporate-social-responsibility/pc/5_5_2.png')],
            ],
            title: t('secE_card5_text'),
            desc: t(`secE_card5_desc`),
        },
        {
            imgs: [
                [require('@publicLocal/corporate-social-responsibility/pc/5_6_1.webp'), require('@publicLocal/corporate-social-responsibility/pc/5_6_1.png')],
            ],
            title: t('secE_card6_text'),
            desc: t(`secE_card6_desc`),
        },
        {
            imgs: [
                [require('@publicLocal/corporate-social-responsibility/pc/5_7_1.webp'), require('@publicLocal/corporate-social-responsibility/pc/5_7_1.png')],
            ],
            title: t('secE_card7_text'),
            desc: t(`secE_card7_desc`),
        },
        {
            imgs: [
                [require('@publicLocal/corporate-social-responsibility/pc/5_8_1.webp'), require('@publicLocal/corporate-social-responsibility/pc/5_8_1.png')],
            ],
            title: t('secE_card8_text'),
            desc: t(`secE_card8_desc`),
        },
        {
            imgs: [
                [require('@publicLocal/corporate-social-responsibility/pc/5_9_1.webp'), require('@publicLocal/corporate-social-responsibility/pc/5_9_1.png')],
            ],
            title: t('secE_card9_text'),
            desc: t.rich(`secE_card9_desc`, {
                link: (text: string) => (
                    <a className="desc-link" href={'https://za.ecoflow.com/products/delta-max-portable-power-station'} target={'_blank'} rel="noreferrer">
                        {text}
                    </a>
                ),
            }),
        },
        {
            imgs: [['https://websiteoss.ecoflow.com/upload/image/1734491622748/F15.jpg', 'https://websiteoss.ecoflow.com/upload/image/1734491622748/F15.jpg']],
            title: t('secE_card13_text'),
            desc: t(`secE_card13_desc`),
        },
        {
            title: t('secE_card11_text'),
            desc: t('secE_card11_desc'),
            imgs: [
                [require('@publicLocal/corporate-social-responsibility/common/B1.jpg'), require('@publicLocal/corporate-social-responsibility/common/B1.jpg')],
                [require('@publicLocal/corporate-social-responsibility/common/B2.jpg'), require('@publicLocal/corporate-social-responsibility/common/B2.jpg')],
            ],
        },
    ];

    const new_add_site_25_08_21 = ['eu', 'cn', 'fr', 'de', 'es', 'it', 'jp', 'us', 'ca', 'za', 'au', 'uk', 'mx'];
    if (new_add_site_25_08_21.includes(locale)) {
        cards[0] = {
            title: t('secE_card16_text'),
            desc: t('secE_card16_desc'),
            webpImg: 'https://websiteoss.ecoflow.com/upload/image/1753858618195/E16_1.jpeg',
            img: 'https://websiteoss.ecoflow.com/upload/image/1753858618195/E16_1.jpeg',
            imgArr: [
                [
                    'https://websiteoss.ecoflow.com/upload/image/1753858618195/E16_1.jpeg',
                    'https://websiteoss.ecoflow.com/upload/image/1753858618195/E16_1.jpeg',
                ],
                [
                    'https://websiteoss.ecoflow.com/upload/image/1753858618162/E16_2.jpeg',
                    'https://websiteoss.ecoflow.com/upload/image/1753858618162/E16_2.jpeg',
                ],
            ],
        };
        cards[3] = {
            title: t('secE_card15_text'),
            desc: t('secE_card15_desc'),
            webpImg: 'https://websiteoss.ecoflow.com/upload/image/1753858056996/E15.jpg',
            img: 'https://websiteoss.ecoflow.com/upload/image/1753858056996/E15.jpg',
            imgArr: [
                ['https://websiteoss.ecoflow.com/upload/image/1753858056996/E15.jpg', 'https://websiteoss.ecoflow.com/upload/image/1753858056996/E15.jpg'],
            ],
        };
        moreArr.push({
            title: t('secE_card10_text'),
            desc: t('secE_card10_desc'),
            // webpImg: require('@publicLocal/corporate-social-responsibility/common/A1.jpg'),
            // img: require('@publicLocal/corporate-social-responsibility/common/A1.jpg'),
            imgs: [
                [require('@publicLocal/corporate-social-responsibility/common/A1.jpg'), require('@publicLocal/corporate-social-responsibility/common/A1.jpg')],
                [require('@publicLocal/corporate-social-responsibility/common/A2.jpg'), require('@publicLocal/corporate-social-responsibility/common/A2.jpg')],
                [require('@publicLocal/corporate-social-responsibility/common/A3.jpg'), require('@publicLocal/corporate-social-responsibility/common/A3.jpg')],
                [require('@publicLocal/corporate-social-responsibility/common/A4.jpg'), require('@publicLocal/corporate-social-responsibility/common/A4.jpg')],
            ],
        });
        moreArr.push({
            title: t('secE_card2_text'),
            desc: t('secE_card2_desc'),
            // webpImg: require('@publicLocal/corporate-social-responsibility/pc/5_2_1.jpg'),
            // img: require('@publicLocal/corporate-social-responsibility/pc/5_2_1.jpg'),
            imgs: [
                [require('@publicLocal/corporate-social-responsibility/pc/5_2_1.jpg'), require('@publicLocal/corporate-social-responsibility/pc/5_2_1.jpg')],
            ],
        });
        moreArr.push({
            title: t('secE_card17_text'),
            desc: t('secE_card17_desc'),
            imgs: [
                ['https://websiteoss.ecoflow.com/upload/image/1754530419201/al2.jpeg', 'https://websiteoss.ecoflow.com/upload/image/1754530419201/al2.jpeg'],
            ],
        });
    }

    return (
        <div className={`csr-E ${css['csr-E']}`}>
            <div className="secE">
                <div className="content-box">
                    <div className="text-box">
                        <p className="title">{t('secE_title')}</p>
                        <p className="desc">{t('secE_desc')}</p>
                    </div>
                    <div className="card-box">
                        {cards?.map((card: any, k: number) => (
                            <div className={`card card${k + 1}`} onClick={() => clickCard(card)} key={k}>
                                <div className="img">
                                    <NextImage webpSrc={card?.webpImg || card.img} src={card.img} alt={card?.title} aria-label={card?.title} />
                                </div>
                                <div className="text-bar">
                                    <p className="text">{card?.title}</p>
                                    <SVGArrow />
                                </div>
                            </div>
                        ))}
                    </div>
                    <p className="more" onClick={() => setMoreVisible(true)}>
                        <span className="more-text">{t('secCommon_more')}</span>
                        <SVGMore />
                    </p>
                </div>
            </div>
            {visible && <CardModal title={modalInfo?.title} desc={modalInfo?.desc} imgs={modalInfo?.imgs} onClose={() => setVisible(false)} />}
            {moreVisible && <More arr={moreArr} onClose={() => setMoreVisible(false)} />}
        </div>
    );
}
